import { render, staticRenderFns } from "./dictionaryRecord.vue?vue&type=template&id=3e3b76d2&scoped=true"
import script from "./dictionaryRecord.vue?vue&type=script&lang=js"
export * from "./dictionaryRecord.vue?vue&type=script&lang=js"
import style0 from "./dictionaryRecord.vue?vue&type=style&index=0&id=3e3b76d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3b76d2",
  null
  
)

export default component.exports